import { schema, types } from 'papr'

export const userFollowSchema = schema(
	{
		from: types.objectId({ required: true }),
		to: types.objectId({ required: true }),
		dateFollowed: types.date({ required: true }),
		source: types.string(),
		recommendedByPublication: types.objectId(),
	},
	{
		defaults: {
			// this doesn't work with the current version of papr
			// dateFollowed: new Date()
		},
	},
)

export type UserFollowDocument = (typeof userFollowSchema)[0]
export type UserFollowDefaults = (typeof userFollowSchema)[1]
